<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('cardsPage.title') }}</h2>
      <p class="text-center">
        {{ $t('cardsPage.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <cards-filter-form :filter-details="filterDetails"/>
      </div>
      <div class="col-12" v-loading="loading" />
    </div>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div class="row mt-2" v-if="!loading && filterDetails && !error">
      <div class="col-12">
        <cards-table :details="data" :filter-details="filterDetails"/>
      </div>
    </div>
  </div>
</template>
<script>
import CardsTable from './CardsTable'
import CardsFilterForm from './CardsFilterForm'
import {BaseAlert} from 'src/components';
import {mapState} from "vuex";

export default {
  name: 'cardsPage',
  components: {
    BaseAlert,
    CardsFilterForm,
    CardsTable
  },
  methods: {},
  computed: {
    ...mapState({
      loading: state => state.cards.loading,
      data: state => state.cards.data,
      filterDetails: state => state.cards.filterDetails,
      error: state => state.cards.error,
    }),
  },
};
</script>
<style>
</style>
